module.exports = __webpack_public_path__ + "img/糖果.4692226a.svg";